import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./style.scss";
import GaugeChart from "../../../shared/chartjs/GaugeChart";
import {
  DegradationChartDummyData,
  GaugeChartDummyData,
  PieChartDummyData,
} from "../../../shared/chartjs/dummyData/SingleDummyData";
import FilterRoadPredict from "../LeftContent/FilterRoadPredict";
import Spacer from "../../../shared/components/Spacer";
import PieChart from "../../../shared/chartjs/PieChart";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import i18n from "../../../localization/i18n";
import DegradationChart from "../../../shared/chartjs/DegradationChart";
import { connect, useDispatch } from "react-redux";
import {
  GetLatestRoadSurveyedFile,
  GetRoadGraphCalculation,
  GetDeteriorationCurveId,
} from "../../../services/actions/RoadAction";
import EditDialog from "../LeftContent/EditDialog";
import { setGraphData } from "../../../shared/chartjs/CustomGraphModule";
import under3 from "./icon/under3.png";
import under4 from "./icon/under4.png";
import { AccessPeriodCard } from "../LeftContent/AccessPeriodCard";

const SurveyedSummary = ({
  isActual,
  isPredicted,
  yearFilter,
  dpYears,
  loggedUser,
  userFilter,
  surfaceTypeFilter,
  surfaces,
  deteriorationCurveList,
  deteriorationCurveId,
}) => {
  const dispatch = useDispatch();
  const [gaugeChartData, setGaugeChartData] = useState(GaugeChartDummyData);
  const [pieChartData, setPieChartData] = useState(PieChartDummyData);
  const [degradationChartData, setDegradationChartData] = useState(
    DegradationChartDummyData
  );
  const [averageScoreValue, setAverageScoreValue] = useState(0);
  const [averageScoreLabel, setAverageScoreLabel] = useState("");
  const [averageScoreColor, setAverageScoreColor] = useState("");
  const [under4Score, setUnder4Score] = useState(0);
  const [under3Score, setUnder3Score] = useState(0);
  const [roadType, setRoadType] = useState("");
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const yearSlider = dpYears.find((dpYear) => dpYear.year == yearFilter);

  const getData = async () => {
    const data = await dispatch(GetLatestRoadSurveyedFile(userFilter));
    if (data && data[0]) {
      setRoadType(data[0].type);
    }
  };

  useEffect(() => {
    if (userFilter != null) {
      getData();
    }
  }, [userFilter]);

  useEffect(() => {
    if (
      userFilter != null &&
      yearFilter != null &&
      surfaces != null &&
      surfaces.length > 0
    ) {
      setGraphData({
        dispatch,
        action: GetRoadGraphCalculation,
        params: { userId: userFilter, year: yearFilter, isActual, isPredicted, roadType },
        yearFilter,
        yearSlider,
        surfaces,
        deteriorationCurveList,
        deteriorationCurveId,
        setGaugeChartData,
        setPieChartData,
        setDegradationChartData,
        setUnder4Score,
        setUnder3Score,
      });
    }
  }, [userFilter, dpYears, yearFilter, isActual, isPredicted, surfaces]);

  useEffect(() => {
    if (userFilter) {
      dispatch(GetDeteriorationCurveId());
    }
  }, [userFilter]);

  useEffect(() => {
    try {
      const deteriorationCurve = deteriorationCurveList.find(
        (deteriorationCurve) => deteriorationCurve.id == deteriorationCurveId
      );
      const newDegradationChartData = JSON.parse(
        JSON.stringify(degradationChartData)
      );
      if (deteriorationCurve) {
        const xYear = JSON.parse(deteriorationCurve.xYear || "[]");
        const ySpm = JSON.parse(deteriorationCurve.ySpm || "[]");
        newDegradationChartData.lineData = xYear.map((x, i) => ({
          x,
          y: ySpm[i],
        }));
        const index1 = ySpm.findIndex(
          (spm) => spm == degradationChartData.currentCondition?.toFixed(0)
        );
        const index2 = ySpm.findIndex(
          (spm) => spm == degradationChartData.averageScore?.toFixed(0)
        );
        if (index1 > -1) {
          newDegradationChartData.currentData = [
            {
              x: xYear[index1],
              y: ySpm[index1],
              title: `Current Condition`,
            },
          ];
        }
        if (yearSlider?.isPredict && yearSlider?.isActual) {
          newDegradationChartData.currentData = [{}];
        }
        if (index2 > -1) {
          newDegradationChartData.predictionData = [
            {
              x: xYear[index2],
              y: ySpm[index2],
              title: `Prediction of ${yearFilter}`,
            },
          ];
        }
      }
      setDegradationChartData(newDegradationChartData);
    } catch (e) {
      console.error(e);
    }
  }, [deteriorationCurveId]);


  return (
    <Box className="gis-map-detail">
      <FilterRoadPredict />
      <Spacer size={20} />
      {(roadType == "SPM_PCI" || roadType == "SPM_PCI_DP") && (
        <Box height="220px" width="100%">
          {gaugeChartData.loaded && (
            <GaugeChart
              datasets={gaugeChartData.datasets}
              setAverageScoreValue={setAverageScoreValue}
              setAverageScoreLabel={setAverageScoreLabel}
              setAverageScoreColor={setAverageScoreColor}
            />
          )}
        </Box>
      )}
      <Spacer size={50} />
      {(roadType == "SPM_PASER" || roadType == "SPM_PCI" || roadType == "SPM_PCI_DP") && (
        <Box height="200px" width="100%">
          {gaugeChartData.loaded && (
            <PieChart
              labels={pieChartData.labels}
              datasets={pieChartData.datasets}
            />
          )}
        </Box>
      )}
      <Spacer size={20} />
      {(roadType == "SPM_PCI" || roadType == "SPM_PCI_DP") &&
        ((!yearSlider?.isPredict && yearSlider?.isActual) ||
          (yearSlider?.isPredict && yearSlider?.isActual && !isPredicted)) && (
          <>
            <Box className="flex-box">
              <Box className="average-score-title">
                {i18n.t("average_score")}
              </Box>
              <Box className="average-score" bgcolor={averageScoreColor}>
                {averageScoreValue}
                <br />
                {averageScoreLabel}
              </Box>
            </Box>
            <Spacer size={20} />
            <Box className="flex-box">
              <Box className="under-img">
                <img src={under4} width="100%" />
              </Box>
              <Box className="under-text">
                <span style={{ fontSize: "1.5em" }}> {under4Score} </span>
                {i18n.t("under4_score")}
              </Box>
            </Box>
            <Spacer size={20} />
            <Box className="flex-box">
              <Box className="under-img">
                <img src={under3} width="100%" />
              </Box>
              <Box className="under-text">
                <span style={{ fontSize: "1.5em" }}> {under3Score} </span>
                {i18n.t("under3_score")}
              </Box>
            </Box>
            <Spacer size={20} />
          </>
        )}
      {roadType == "SPM_PCI_DP" && (deteriorationCurveId > 0) &&
        ((yearSlider?.isPredict && !yearSlider?.isActual) ||
          (yearSlider?.isPredict && yearSlider?.isActual && isPredicted)) && (
          <Box height="350px" width="100%">
            <Box className="deterioration-curve-title">
              {i18n.t("deterioration_curve")}
            </Box>
            <DegradationChart
              levelBands={degradationChartData.levelBands}
              lineData={degradationChartData.lineData}
              currentData={degradationChartData.currentData}
              predictionData={degradationChartData.predictionData}
            />
          </Box>
        )}
      <EditDialog
        open={openEditDialog}
        handleClose={() => setOpenEditDialog(false)}
      />
      <AccessPeriodCard />
    </Box>
  );
};

export default connect((state) => ({
  isActual: state.gis.isActual,
  isPredicted: state.gis.isPredicted,
  yearFilter: state.road.yearFilter,
  dpYears: state.road.dpYears,
  loggedUser: state.auth.user,
  userFilter: state.road.userFilter,
  surfaceTypeFilter: state.road.surfaceTypeFilter,
  surfaces: state.surface.surfaces,
  deteriorationCurveList: state.road.deteriorationCurveList,
  deteriorationCurveId: state.road.deteriorationCurveId,
}))(SurveyedSummary);
